import {Component, Input } from '@angular/core';
import {HoriznotalTimeSpan, HorizontalTimelineMarker} from './models/horizontal-time-span.model';
import {Logger, LoggerService} from '../../services/logger.service';

@Component({
  selector: 'app-horizontal-timeline',
  templateUrl: './horizontal-timeline.component.html',
  styleUrls: ['./horizontal-timeline.component.scss'],
})
export class HorizontalTimelineComponent {
  @Input() items: HoriznotalTimeSpan[];
  @Input() marker: HorizontalTimelineMarker;

  private logger: Logger; components; columnDefs;
  timeSpans: HoriznotalTimeSpan[];
  markerTooltipData: string;

  constructor(
    private loggerFactory: LoggerService,
  ) {
    this.logger = this.loggerFactory.getLogger("HorizontalTimelineComponent");
  }
}
